import { AfterViewInit, Component, Input, OnDestroy, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { MobileSidenavService } from '@app/services/mobile-sidenav.service';
import { TranslatableKey } from '@app/types/translatable.type';

export type NavItem = {
    text: TranslatableKey;
    href: string;
    complete: boolean;
};

export type NavGroup = {
    title: TranslatableKey;
    steps: NavItem[];
};

@Component({
    selector: 'app-self-serve-side-nav',
    templateUrl: './side-nav.template.html',
    styleUrls: ['./side-nav.style.scss'],
})
export class SideNavComponent implements AfterViewInit, OnDestroy {
    @Input() navGroups: NavGroup[] = [];
    @ViewChild('mobileSidenavContent') mobileSidenavContent!: TemplateRef<unknown>;

    constructor(
        private mobileSidenavService: MobileSidenavService,
        private viewContainerRef: ViewContainerRef
    ) {}

    ngAfterViewInit(): void {
        // the sidebar will use our content instead of the default content
        this.mobileSidenavService.setPortal(this.mobileSidenavContent, this.viewContainerRef);
    }

    ngOnDestroy(): void {
        this.mobileSidenavService.clearPortal();
    }

    /**
     * closeSideNav will tell the mobile side nav to close
     * on non-mobile view the nav won't be open so this is a no-op
     */
    closeSideNav(): void {
        this.mobileSidenavService.close();
    }
}
